import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceAttachment, DeviceStatus } from '~status/models/device-status';
import { environment } from '~environment';

@Injectable({
  providedIn: 'root'
})
export class StatusService {
    private readonly http = inject(HttpClient);
    private readonly url: string = environment.serverBaseUrl + 'device';

    getStatus(deviceId: string): Observable<DeviceStatus> {
        return this.http.get<DeviceStatus>(this.url + `/${encodeURIComponent(deviceId)}`);
    }

    uploadAttachment(deviceId: string, file: File): Observable<DeviceAttachment> {
        const body = new FormData();
        body.append('file', file, file.name);
        return this.http.post<DeviceAttachment>(this.url + `/${encodeURIComponent(deviceId)}/attachments`, body);
    }

    deleteAttachment(deviceId: string, id: string): Observable<void> {
        return this.http.delete<void>(this.url + `/${encodeURIComponent(deviceId)}/attachments/${encodeURIComponent(id)}`);
    }

    getImpersonationToken() {
        return this.http.get<{ email: string, token: string }>(this.url + '/impersonate');
    }
}
